module.exports = __webpack_public_path__ + "img/add.5a7990a3.svg";